module.exports = __webpack_public_path__ + "img/malawi.e0ae7213.svg";